import type { PayoutProfile, PayoutProfileStatus } from "@/types";

import { BaseApi } from "./base.api";

class AdminPayoutsApi extends BaseApi {
  list(status?: PayoutProfileStatus) {
    return this.request<PayoutProfile[]>("/admin/payout-profiles", {
      query: status ? { status } : {},
    });
  }

  review(id: string, outcome: "approved" | "rejected", note?: string) {
    return this.request<PayoutProfile>(`/admin/payout-profiles/${id}/review`, {
      method: "POST",
      body: { outcome, note },
    });
  }
}

export const adminPayoutsApi = new AdminPayoutsApi();
